<template>
  <div class="cps-connexion-fields container">
    <h2 class="connexion-title">{{ $texts.formTemporaryCodeTitle }}</h2>
    <input-field
      v-if="formData.field_MobilePhone && formData.field_MobilePhone.visible"
      fieldId="MobilePhone"
      :name="formData.field_MobilePhone.name"
      :description="formData.field_MobilePhone.description"
      :tooltip="formData.field_MobilePhone.tooltip"
      :required="formData.field_MobilePhone.required"
      :enabled="formData.field_MobilePhone.enabled"
      :pattern="formData.field_MobilePhone.regexp"
      v-model="userData.mobilePhone"
      type="phone"
    ></input-field>
  </div>
</template>

<script>
import Vue from "vue";
import InputField from "../fields/InputField.vue";

export default Vue.extend({
  name: "cps-connexion-fields",

  components: {
    InputField
  },

  props: {
    formData: {
      type: Object,
      required: true
    },
    userData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {},

  methods: {},

  watch: {}
});
</script>

<style scoped>
.connexion-title {
  font-size: 25px;
  color: #2fa1ba;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
